import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {UniversityApplicantInfo} from '../../../model/university-applicant-info';
import {EnrollCabinet} from '../../../model/enroll-cabinet';
import {Utils} from '../../../../../../common/services/Utils';
import {ExamsDataItem} from './model/ExamsDataItem';
import {ExamsData} from './model/ExamsData';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.scss']
})
export class CommonDialogComponent implements OnInit {
  title: string = '';
  type: number = null;
  send_button_title: string = '';
  dics: any;
  enrollCabinet: EnrollCabinet;
  applicationInfo: UniversityApplicantInfo = new UniversityApplicantInfo();
  statusInfo = {
    sendingToRevisionContent: '',
    rejectingApplicationReason: '',
    rejectingGrantReason: '',
  };
  interviewData = {
    date: null,
    time: null
  };
  examsData: ExamsData = new ExamsData();

  constructor(public dialogRef: MatDialogRef<CommonDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private utils: Utils,
              public _translateService: TranslateService) {
    if (data) {
      this.title = data.title;
      this.type = data.type;
      this.send_button_title = data.send_button_title;
      this.enrollCabinet = data.enrollCabinet;
      this.applicationInfo = data.applicationInfo;
      this.statusInfo = data.statusInfo;
      this.interviewData = data.interviewData;
      this.dics = data.dics;
      if (this.data.dics.admissionSubjects) {
        this.data.dics.admissionSubjects.forEach(item => {
          this.examsData.admissionSubjects.push(this.getExamsDataItem(item));
        });
        console.log('this.examsData.admissionSubjects', this.examsData.admissionSubjects);
      }
    }
  }

  getExamsDataItem(item): any {
    const examsDataItem: ExamsDataItem = new ExamsDataItem();
    examsDataItem.id = item.id;
    examsDataItem.enrollId = item.enrollId;
    examsDataItem.subjectId = item.subjectId;
    examsDataItem.name = (this._translateService.currentLang === 'kz' ? item.subject.nameKz : item.subject.nameRu);
    examsDataItem.balls = this.getBallsArrFromSubj(item.subject);
    examsDataItem.admissionDate = item.admissionDate;
    examsDataItem.admissionTime = item.admissionTime;
    return examsDataItem;
  }

  getBallsArrFromSubj(subj): any {
    if (subj) {
      const arr = [];
      for (let i = subj.minPoints; i <= subj.maxPoints; i++) {
        arr.push(i);
      }
      return arr;
    }
    return [];
  }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.type === 3) {
      this.data.examsData = this.examsData;
    }
    this.dialogRef.close(this.data);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/dialogs/common-dialog/common-dialog.component.ts